import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BsClipboard2Check, BsClipboardPlus, BsDownload, BsFillClipboard2PlusFill, BsFloppy, BsNewspaper, BsTrash } from 'react-icons/bs';
import { useWindowDimensions } from '../../../utils';
import { color_white, color_grey_dark, color_grey_ultra_light, color_red_default, color_red_default_t20, color_green_pastel_light, color_green_dark, color_black_ultra_light, color_red_active, color_grey_light } from '../../../constants/colors';
import axios from 'axios';
import Config from '../../../Config';
import { OnestBoldDefault, OnestNormalDefault, OnestNormalSmall } from '../../styled/TextComponents'; // Adjust the path if needed
import { InfinitySpin } from "react-loader-spinner";
import { useI18n } from '../../../i18n/I18nProvider';

const AdminLibraryFileBlock = ({ libraryFileData, onFetchLibrary, folders }) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const [index, setIndex] = useState(+libraryFileData.index ? +libraryFileData.index : 0);
    const [name, setName] = useState(libraryFileData.name ? libraryFileData.name : "");
    const [nameEn, setNameEn] = useState(libraryFileData.name_en ? libraryFileData.name_en : "");
    const [folder, setFolder] = useState(libraryFileData.folder ? libraryFileData.folder : "");
    const [isWaiting, setIsWaiting] = useState(false);

    const handlePatch = async (key, value) => {
        console.log("handlePatch in AdminLibraryFileBlock: ", key, value);
        setIsWaiting(true)
        const backendAddr = `${Config.BACKEND_ADDR}/library/`;
        axios.patch(backendAddr, {
            library_id: libraryFileData.id,
            [key]: value,
        }).then(response => {
            if (response.status === 200) {
                onFetchLibrary()
                setIsWaiting(false);
            }
        }).catch(error => {
            console.error('patch file:', error);
        });
    };

    const handleSave = useCallback(() => {
        setIsWaiting(true)
        const backendAddr = `${Config.BACKEND_ADDR}/library/`;
        axios.patch(backendAddr, {
            library_id: libraryFileData.id,
            name: name,
            name_en: nameEn,
            index: index,
            folder: folder
        }).then(response => {
            if (response.status === 200) {
                onFetchLibrary()
                setIsWaiting(false);
            }
        }).catch(error => {
            console.error('patch file:', error);
        });
    }, [libraryFileData.id, name, nameEn, index, folder, onFetchLibrary]);

    const handleOnBlurName = useCallback(() => {
        if (name !== libraryFileData.name) {
            handlePatch("name", name);
        }
    }, [libraryFileData.name, name]);

    const handleOnChangeName = useCallback((e) => {
        setName(e.target.value)
    }, [])

    const handleOnBlurNameEn = useCallback(() => {
        if ((nameEn || "") !== (libraryFileData.name_en || "")) {
            handlePatch("name_en", nameEn);
        }
    }, [libraryFileData.name_en, nameEn]);

    const handleOnChangeNameEn = useCallback((e) => {
        setNameEn(e.target.value)
    }, [])

    const handleOnBlurFolder = useCallback(() => {
        if (folder !== libraryFileData.folder) {
            handlePatch("folder", folder);
        }
    }, [libraryFileData.folder, folder]);

    const handleOnChangeFolder = useCallback((e) => {
        setFolder(e.target.value)
    }, [])

    const handleOnBlurIndex = useCallback(() => {
        if (index !== libraryFileData.index) {
            handlePatch("index", index)
        }
    }, [index, libraryFileData.index])

    const handleOnChangeIndex = useCallback((e) => {
        setIndex(e.target.value)
    }, [])

    const handleOnClickIsDounload = useCallback(() => {
        let is_download = !libraryFileData.is_download;
        handlePatch("is_download", is_download);
    }, [libraryFileData.is_download])

    const handleOnClickDelete = useCallback(() => {
        if (window.confirm(t("Вы уверены, что хотите удалить этот файл?"))) {
            setIsWaiting(true)
            const backendAddr = `${Config.BACKEND_ADDR}/library/${libraryFileData.id}`;
            axios.delete(backendAddr, {
                data: {
                    library_id: libraryFileData.id
                }
            }).then(response => {
                if (response.status === 200) {
                    onFetchLibrary()
                }
            }).catch(error => {
                console.error('delete file:', error);
            });
        }
    }, [libraryFileData.id, onFetchLibrary, t])

    const handleAddToNews = useCallback(async () => {
        try {
            setIsWaiting(true)
            const response = await axios.put(`${Config.BACKEND_ADDR}/changes/`, {
                type: "library",
                address: `${libraryFileData.id}`,
                text: t("Опубликован новый документ:")
            });
            if (response.status === 200) {
                alert(t("Файл успешно добавлен в новости"));
            }
            setIsWaiting(false)
        } catch (error) {
            console.error('Error adding file to news:', error);
        }
    }, [libraryFileData.id, t])

    return (
        <div
            style={{
                position: "relative",
                width: screenWidth > 530 ? 380 : screenWidth - 100,
                height: screenWidth > 530 ? "auto" : "auto",
                minHeight: screenWidth > 530 ? 600 : undefined,
                borderRadius: 20,
                display: "flex",
                flexDirection: "column",
                padding: 15,
                gap: 8,
                backgroundColor: color_white,
                alignItems: "center"
            }}>
            {isWaiting &&
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        borderRadius: 20,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: color_red_default_t20,
                    }}

                >
                    <InfinitySpin visible={true} width={200} color={color_red_default} />
                </div>
            }
            <OnestBoldDefault style={{ marginBottom: 10 }}>
                id: {libraryFileData.id}
            </OnestBoldDefault>
            <div style={{
                display: "flex",
                flexDirection: screenWidth > 530 ? "row" : "column",
                justifyContent: screenWidth > 530 ? "space-between" : "flex-start",
                width: "100%"
            }}>

                <img
                    style={{
                        width: screenWidth > 530 ? 180 : screenWidth - 160,
                        height: screenWidth > 530 ? 141 : "auto",
                        borderRadius: 10,
                        objectFit: "cover",
                        backgroundColor: color_grey_ultra_light,
                    }}
                    src={Config.CLOUD_ADDR + '/' + libraryFileData.image_path}
                    alt={"fileImage"}
                />
                <div
                    style={{
                        width: screenWidth > 530 ? 180 : screenWidth - 160,
                        height: "auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        marginTop: 8,
                        gap: 5,

                    }}
                >
                    <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                        {t("загрузите обложку:")}
                    </OnestNormalSmall>
                    <input
                        placeholder={t("загрузите обложку")}
                        type="file"
                        accept="image/*"
                        style={{
                            width: screenWidth > 530 ? 160 : screenWidth - 160,
                            height: 40,
                            borderRadius: 10,
                            paddingLeft: 15,
                            color: color_grey_dark,
                            backgroundColor: color_grey_ultra_light,
                            border: "0px solid grey"
                        }}
                        onChange={async (e) => {
                            setIsWaiting(true);
                            const file = e.target.files[0];
                            if (file) {
                                const formData = new FormData();
                                formData.append('file', file);
                                formData.append('library_id', libraryFileData.id);

                                try {
                                    const response = await axios.post(`${Config.BACKEND_ADDR}/cloud/put_library_file/${libraryFileData.id}`, formData);
                                    console.log("response from put_library_file: ", response);
                                    if (response.status === 200) {
                                        //alert("Файл успешно загружен");
                                        await handlePatch("image_path", response.data.file_id);
                                        onFetchLibrary();
                                    }
                                } catch (error) {
                                    console.error('Error uploading file:', error);
                                }
                            }
                        }}
                    />
                    <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                        {t("загрузите файл:")}
                    </OnestNormalSmall>
                    <input
                        placeholder={t("загрузите файл")}
                        type="file"
                        style={{
                            width: screenWidth > 530 ? 160 : screenWidth - 160,
                            height: 40,
                            borderRadius: 10,
                            paddingLeft: 15,
                            color: color_grey_dark,
                            backgroundColor: color_grey_ultra_light,
                            border: "0px solid grey"
                        }}
                        onChange={async (e) => {
                            setIsWaiting(true);
                            const file = e.target.files[0];
                            if (file) {
                                const formData = new FormData();
                                formData.append('file', file);
                                formData.append('library_id', libraryFileData.id);

                                try {
                                    const response = await axios.post(`${Config.BACKEND_ADDR}/cloud/put_library_file/${libraryFileData.id}`, formData);
                                    console.log("response from put_library_file: ", response);
                                    if (response.status === 200) {

                                        await handlePatch("index_html_path", response?.data?.file_id);
                                        onFetchLibrary();
                                    }
                                } catch (error) {
                                    console.error('Error uploading file:', error);
                                }
                            }
                        }}
                    />
                    <OnestNormalSmall style={{ color: libraryFileData.index_html_path ? color_green_dark : color_black_ultra_light }}>
                        {libraryFileData.index_html_path
                            ? t("файл RU загружен")
                            : t("русская версия файла")}
                    </OnestNormalSmall>
                    <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                        {t("загрузите файл (EN):")}
                    </OnestNormalSmall>
                    <input
                        placeholder={t("загрузите файл")}
                        type="file"
                        style={{
                            width: screenWidth > 530 ? 160 : screenWidth - 160,
                            height: 40,
                            borderRadius: 10,
                            paddingLeft: 15,
                            color: color_grey_dark,
                            backgroundColor: color_grey_ultra_light,
                            border: "0px solid grey"
                        }}
                        onChange={async (e) => {
                            setIsWaiting(true);
                            const file = e.target.files[0];
                            if (file) {
                                const formData = new FormData();
                                formData.append('file', file);
                                formData.append('library_id', libraryFileData.id);

                                try {
                                    const response = await axios.post(`${Config.BACKEND_ADDR}/cloud/put_library_file/${libraryFileData.id}`, formData);
                                    if (response.status === 200) {
                                        await handlePatch("index_html_path_en", response?.data?.file_id);
                                        onFetchLibrary();
                                    }
                                } catch (error) {
                                    console.error('Error uploading English file:', error);
                                }
                            }
                        }}
                    />
                    <OnestNormalSmall style={{ color: libraryFileData.index_html_path_en ? color_green_dark : color_black_ultra_light }}>
                        {libraryFileData.index_html_path_en
                            ? t("файл EN загружен")
                            : t("если нет — откроется русская версия")}
                    </OnestNormalSmall>
                </div>
            </div>
            <div style={{
                display: "flex",
                flexDirection: screenWidth > 530 ? "row" : "column",
                alignItems: "center",
                width: "100%"
            }}>
                <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                    {t("название:")}
                </OnestNormalSmall>
                <input
                    placeholder={t("имя")}
                    style={{
                        width: screenWidth > 530 ? 160 : screenWidth - 160,
                        height: 40,
                        borderRadius: 10,
                        paddingLeft: 15,
                        color: color_grey_dark,
                        backgroundColor: color_grey_ultra_light,
                        border: "0px solid grey"
                    }}
                    value={name}
                    onChange={handleOnChangeName}
                    onBlur={handleOnBlurName}
                />
            </div>
            <div style={{
                display: "flex",
                flexDirection: screenWidth > 530 ? "row" : "column",
                alignItems: "center",
                width: "100%"
            }}>
                <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                    {t("название на английском:")}
                </OnestNormalSmall>
                <input
                    placeholder={t("название на английском")}
                    style={{
                        width: screenWidth > 530 ? 160 : screenWidth - 160,
                        height: 40,
                        borderRadius: 10,
                        paddingLeft: 15,
                        color: color_grey_dark,
                        backgroundColor: color_grey_ultra_light,
                        border: "0px solid grey"
                    }}
                    value={nameEn}
                    onChange={handleOnChangeNameEn}
                    onBlur={handleOnBlurNameEn}
                />
            </div>
            <div style={{
                display: "flex",
                flexDirection: screenWidth > 530 ? "row" : "column",
                alignItems: "center",
                width: "100%"
            }}>
                <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                    {t("порядковый номер:")}
                </OnestNormalSmall>
                <div style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 10,
                }}>
                    <input
                        type="number"
                        placeholder={t("порядковый номер")}
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            paddingLeft: 15,
                            color: color_grey_dark,
                            backgroundColor: color_grey_ultra_light,
                            border: "0px solid grey"
                        }}
                        value={index}
                        onChange={handleOnChangeIndex}
                        onBlur={handleOnBlurIndex}
                    />
                    <OnestNormalSmall
                        style={{
                            color: color_grey_dark,
                            //textAlign: 'center' 
                        }}>
                        {t("если 0, то скрыт из библиотеки")}
                    </OnestNormalSmall>
                </div>
            </div>
            <OnestNormalSmall style={{ color: color_black_ultra_light }}>
                {t("папка (выбери или напиши новую):")}
            </OnestNormalSmall>

            <div style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
                overflowY: "auto",
            }}>
                {folders.map((folderItem, index) => (
                    <div key={index} 
                    onClick={() => setFolder(folderItem)}
                    style={{
                        padding: "5px 10px",
                        borderRadius: 20,
                        backgroundColor: color_grey_light,
                        color: folderItem === folder ? color_red_active : color_black_ultra_light,
                        cursor: "pointer",
                    }}>
                        {folderItem}
                    </div>
                ))}
                <input
                    placeholder={t("название новой папки")}
                    style={{
                        width: 180,
                        height: 40,
                        borderRadius: 10,
                        paddingLeft: 15,
                        color: color_grey_dark,
                        backgroundColor: color_grey_ultra_light,
                        border: "0px solid grey"
                    }}
                    value={folder}
                    onChange={handleOnChangeFolder}
                />
            </div>

            <div style={{
                width: "100%",
                marginTop: "auto",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}>

                <div
                    style={{
                        cursor: "pointer",
                        backgroundColor: color_grey_ultra_light,
                        borderRadius: 10,
                        padding: "10px 20px",
                    }}>
                    <BsDownload
                        style={{
                            color: libraryFileData.is_download ? color_red_default : color_grey_dark,
                            fontSize: 25
                        }}
                        onClick={handleOnClickIsDounload}
                    />
                </div>
                <div
                    style={{
                        cursor: "pointer",
                        backgroundColor: color_green_pastel_light,
                        borderRadius: 10,
                        padding: "10px 20px",
                    }}>
                    <BsFloppy
                        style={{
                            color: color_green_dark,
                            fontSize: 25
                        }}
                        onClick={handleSave}
                    />
                </div>
                {screenWidth > 530 && 
                    <div
                        style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: color_green_pastel_light,
                            borderRadius: 10,
                            padding: "10px 20px",
                        }}>
                        
                        <BsClipboardPlus
                            style={{
                                color: color_green_dark,
                                fontSize: 25
                            }}
                            onClick={handleAddToNews}
                        />
                    </div>
                }
                <div
                    style={{
                        cursor: "pointer",
                        backgroundColor: color_red_default_t20,
                        borderRadius: 10,
                        padding: "10px 20px",
                    }}>
                    <BsTrash
                        style={{
                            color: color_red_default,
                            fontSize: 25
                        }}
                        onClick={handleOnClickDelete}
                    />
                </div>

            </div>
            {screenWidth < 531 && <button
                style={{
                    alignSelf: "flex-start",
                    padding: "10px 20px",
                    backgroundColor: color_green_pastel_light,
                    border: `1px solid ${color_green_dark}`,
                    borderRadius: 10,
                    color: color_green_dark,
                    cursor: "pointer",
                    fontFamily: "Onest"
                }}
                onClick={handleAddToNews}
            >
                {t('опубликовать в "Обновления"')}
            </button>}
        </div>
    );
};

export default AdminLibraryFileBlock;